import React, { useState, useEffect } from 'react';
import './styles.scss';
import lib from '../../../../src/helpers/lib';
import Skeleton from 'react-loading-skeleton';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faBolt,
  faBullseye,
  faChartBar,
  faCheckCircle,
  faCircleCheck,
  faMoneyBillWaveAlt,
  faTriangleExclamation
} from '@fortawesome/free-solid-svg-icons';

export default function BigNumberMetaContratante({ source }) {
  const [cardData, setCardData] = useState({
    pedidos: null,
    vendas: null,
    meta: null,
    objetivo: null,
    metaFaltante: null,
    diaAtual: null,
    valorEmCarteira: null,
    vendaDiariaObjetivo: null,
    objetivoRealizado: null,
    previsaoObjetivo: null,
    performanceVendaDiaria: null,
    performanceObjetivoRealizado: null,
    performancePrevisaoObjetivo: null
  });

  useEffect(() => {
    if (source) {
      let dateAtual = new Date();
      let diaAtual = dateAtual.getDate();

      dateAtual.setMonth(dateAtual.getMonth() + 1);
      dateAtual.setHours(0, 0, 0, 0);
      dateAtual.setDate(0);

      let diasMes = dateAtual.getDate();
      let porcentagemDiasPassados = (diaAtual / diasMes) * 100;

      let performanceVendaIdeal = diasMes != 0 ? source?.valorMetaMes / diasMes : 0;

      setCardData({
        diaAtual: diaAtual,
        pedidos: source.valorPedido,
        valorEmCarteira: source.valorEmCarteira,
        vendas: source.valorFaturado,
        meta: source.valorMetaMes,
        objetivo: source.objetivoRealizado,
        metaFaltante: source.objetivoFaltante,
        vendaDiariaObjetivo: source.vendaDiariaObjetivo,
        objetivoRealizado: source.objetivoRealizado,
        previsaoObjetivo: source.previsaoObjetivo,
        performanceVendaDiaria: performanceVendaIdeal < source.vendaDiariaObjetivo,
        performanceObjetivoRealizado: porcentagemDiasPassados < source.objetivoRealizado,
        performancePrevisaoObjetivo: porcentagemDiasPassados < source.previsaoObjetivo
      });
      // if (metaContratante?.dias) {
      //   let ultimoDia = metaContratante.dias.pop();

      //   let pedidos = ultimoDia.valor;
      //   let vendas = ultimoDia.valorFaturado;
      //   let meta = ultimoDia.meta;

      //   let objetivo,
      //     metaFaltante = 0;

      //   if (meta > 0) {
      //     objetivo = Math.round((vendas / meta) * 100 * 100) / 100;
      //     metaFaltante = meta - vendas;
      //   }

      //   const newCardData = {
      //     pedidos: pedidos,
      //     vendas: vendas,
      //     meta: meta,
      //     objetivo: objetivo,
      //     metaFaltante: metaFaltante
      //   };

      //   console.log(newCardData);
      //   setCardData(newCardData);
    } else {
      setCardData({ pedidos: null, vendas: null, meta: null, objetivo: null, metaFaltante: null });
    }
  }, [source]);

  return (
    <div className="container-fluid big-number mt-4">
      <div className="row d-flex">
        {/* Card 1 */}
        <div className="col mb-4">
          <div className="card bg-secondary shadow h-100 py-2">
            {/* CORRIGIDO: Adicionadas classes flex para centralizar o conteúdo verticalmente */}
            <div className="card-body d-flex flex-column justify-content-center">
              <div className="row no-gutters align-items-center text-white">
                <div className="col mr-2">
                  <div className="font-weight-bold mb-1">
                    <span style={{ fontWeight: '700' }} className="text-uppercase">
                      <FontAwesomeIcon icon={faBolt} />
                      Pedidos no Mês
                    </span>
                  </div>
                  <div className="h3 mb-0">
                    {typeof cardData.pedidos === 'number' ? (
                      Math.floor(cardData.pedidos).toLocaleString('pt-br', {
                        style: 'currency',
                        currency: 'BRL',
                        maximumFractionDigits: 0
                      })
                    ) : (
                      <Skeleton count={1} />
                    )}
                  </div>
                </div>
                <div className="col-auto">
                  <i className="fas fa-calendar fa-2x text-gray-300"></i>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Card 2 */}
        <div className="col mb-4">
          <div className="card bg-custom-gray shadow h-100 py-2">
            {/* CORRIGIDO: Adicionadas classes flex para centralizar o conteúdo verticalmente */}
            <div className="card-body d-flex flex-column justify-content-center text-white">
              <div className="row no-gutters align-items-center">
                <div className="col mr-2">
                  <div className="mb-1">
                    <span style={{ fontWeight: '700' }} className="text-uppercase">
                      <FontAwesomeIcon icon={faMoneyBillWaveAlt} />
                      EM CARTEIRA
                    </span>
                  </div>
                  <div className="h3 mb-0">
                    {typeof cardData.valorEmCarteira === 'number' ? (
                      Math.floor(cardData.valorEmCarteira).toLocaleString('pt-br', {
                        style: 'currency',
                        currency: 'BRL',
                        maximumFractionDigits: 0
                      })
                    ) : (
                      <Skeleton count={1} />
                    )}
                  </div>
                </div>
                <div className="col-auto">
                  <i className="fas fa-dollar-sign fa-2x text-gray-300"></i>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Card 3 */}
        <div className="col mb-4">
          <div className="card bg-secondary shadow h-100 py-2">
            {/* CORRIGIDO: Adicionadas classes flex para centralizar o conteúdo verticalmente */}
            <div className="card-body d-flex flex-column justify-content-center text-white">
              <div className="row no-gutters align-items-center">
                <div className="col mr-2">
                  <div className="mb-1">
                    <span style={{ fontWeight: '700' }} className="text-uppercase">
                      <FontAwesomeIcon icon={faMoneyBillWaveAlt} />
                      FATURADO NO MÊS
                    </span>
                  </div>
                  <div className="h3 mb-0">
                    {typeof cardData.vendas === 'number' ? (
                      Math.floor(cardData.vendas).toLocaleString('pt-br', {
                        style: 'currency',
                        currency: 'BRL',
                        maximumFractionDigits: 0
                      })
                    ) : (
                      <Skeleton count={1} />
                    )}
                  </div>
                </div>
                <div className="col-auto">
                  <i className="fas fa-dollar-sign fa-2x text-gray-300"></i>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Card 4 */}
        <div className="col mb-4">
          <div className="card bg-custom-gray text-white shadow h-100 py-2">
            {/* CORRIGIDO: Adicionadas classes flex para centralizar o conteúdo verticalmente */}
            <div className="card-body d-flex flex-column justify-content-center">
              <div className="row no-gutters align-items-center">
                <div className="col mr-2">
                  <div className="font-weight-bold mb-1">
                    <span style={{ fontWeight: '700' }} className="text-uppercase">
                      <FontAwesomeIcon icon={faBullseye} />
                      Objetivo no Mês
                    </span>
                  </div>
                  <div className="h3 mb-0">
                    {typeof cardData.meta === 'number' ? (
                      Math.floor(cardData.meta).toLocaleString('pt-br', {
                        style: 'currency',
                        currency: 'BRL',
                        maximumFractionDigits: 0
                      })
                    ) : (
                      <Skeleton count={1} />
                    )}
                  </div>
                </div>
                <div className="col-auto">
                  <i className="fas fa-dollar-sign fa-2x text-gray-300"></i>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Card 4 */}
        {/* <div className="col mb-4">
          <div className="card bg-custom-gray text-white shadow h-100 py-2">
            <div className="card-body d-flex flex-column justify-content-center">
              <div className="row no-gutters align-items-center">
                <div className="col mr-2">
                  <div className="font-weight-bold mb-1">
                    <span style={{ fontWeight: '700' }} className="text-uppercase">
                      <FontAwesomeIcon icon={faCircleCheck} />
                      Objetivo Realizado
                    </span>
                  </div>
                  <div className="row no-gutters align-items-center">
                    <div className="col-auto">
                      <div className="h3 mb-0 mr-3 font-weight-bold">
                        {lib.formatToNumeric(
                          cardData.objetivo > 0 ? cardData.objetivo : 0,
                          2,
                          true
                        )}
                        %
                      </div>
                    </div>
                    <div className="col">
                      <div className="progress progress-sm mr-2">
                        <div
                          className="progress-bar bg-primary"
                          role="progressbar"
                          style={{ width: `${cardData.objetivo}%` }}
                          aria-valuenow={cardData.objetivo}
                          aria-valuemin="0"
                          aria-valuemax="100"
                        ></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-auto">
                  <i className="fas fa-clipboard-list fa-2x text-gray-300"></i>
                </div>
              </div>
            </div>
          </div>
        </div> */}

        {/* Card 5 */}
        <div className="col mb-4">
          <div className="card bg-secondary text-white shadow h-100 py-2">
            {/* CORRIGIDO: Adicionadas classes flex para centralizar o conteúdo verticalmente */}
            <div className="card-body d-flex flex-column justify-content-center">
              <div className="row no-gutters align-items-center">
                <div className="col mr-2">
                  <div className="font-weight-bold mb-1">
                    <span style={{ fontWeight: '700' }} className="text-uppercase">
                      <FontAwesomeIcon icon={faChartBar} />
                      Objetivo Faltante
                    </span>
                  </div>
                  <div className="h3 mb-0">
                    {typeof cardData.metaFaltante === 'number' ? (
                      Math.floor(cardData.metaFaltante).toLocaleString('pt-br', {
                        style: 'currency',
                        currency: 'BRL',
                        maximumFractionDigits: 0
                      })
                    ) : (
                      <Skeleton count={1} />
                    )}
                  </div>
                </div>
                <div className="col-auto">
                  <i className="fas fa-comments fa-2x text-gray-300"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Objetivo detalhado */}
      <div className="row mt-4">
        <h3>Análise de Performance</h3>
      </div>

      <div className="row mt-2">
        <div className="col-12 col-lg-4 mb-3">
          <div className="card shadow h-100 p-3">
            <span style={{ fontWeight: '700' }} className="text-uppercase font-weight-bold mb-1">
              Venda Diária Objetivo
            </span>

            {typeof cardData?.vendaDiariaObjetivo === 'number' ? (
              <div className="mt-4">
                <div className="row">
                  <span className="col" style={{ fontWeight: '700' }}>
                    {cardData?.vendaDiariaObjetivo?.toLocaleString('pt-br', {
                      style: 'currency',
                      currency: 'BRL',
                      maximumFractionDigits: 2
                    })}
                  </span>

                  <span className="col d-flex justify-content-flex-end">
                    {cardData?.performanceVendaDiaria ? (
                      <span className="text-green">
                        <FontAwesomeIcon icon={faCheckCircle} className="mr-0" />
                        No Ritmo
                      </span>
                    ) : (
                      <span className="text-warning">
                        <FontAwesomeIcon icon={faTriangleExclamation} className="mr-0" />
                        Atrás
                      </span>
                    )}
                  </span>
                </div>
                <span className="detalhe-objetivo-font">
                  Acumulado: Dia {cardData?.diaAtual} *{' '}
                  {cardData?.vendaDiariaObjetivo?.toLocaleString('pt-br', {
                    style: 'currency',
                    currency: 'BRL',
                    maximumFractionDigits: 2
                  })}{' '}
                  ={' '}
                  {(cardData?.diaAtual * cardData?.vendaDiariaObjetivo)?.toLocaleString('pt-br', {
                    style: 'currency',
                    currency: 'BRL',
                    maximumFractionDigits: 2
                  })}
                </span>
              </div>
            ) : (
              <Skeleton count={1} />
            )}
          </div>
        </div>

        <div className="col-12 col-lg-4 mb-3">
          <div className="card shadow h-100 p-3">
            <span style={{ fontWeight: '700' }} className="text-uppercase font-weight-bold mb-1">
              Objetivo Realizado
            </span>
            {typeof cardData?.objetivo === 'number' ? (
              <div>
                <div className="row">
                  <span className="col mt-3" style={{ fontWeight: '700' }}>
                    {lib.formatToNumeric(
                      cardData.objetivo > 0 ? (cardData?.vendas / cardData?.meta) * 100 : 0,
                      2,
                      true
                    )}
                    %
                  </span>

                  <span className="col d-flex justify-content-flex-end mt-3">
                    {cardData?.performanceObjetivoRealizado ? (
                      <span className="text-green">
                        <FontAwesomeIcon icon={faCheckCircle} className="mr-0" />
                        No Ritmo
                      </span>
                    ) : (
                      <span className="text-warning">
                        <FontAwesomeIcon icon={faTriangleExclamation} className="mr-0" />
                        Atrás
                      </span>
                    )}
                  </span>
                </div>
                <div className="col">
                  <div className="progress progress-sm mr-2">
                    <div
                      className="progress-bar bg-primary"
                      role="progressbar"
                      style={{ width: `${(cardData?.vendas / cardData?.meta) * 100}%` }}
                      aria-valuenow={(cardData?.vendas / cardData?.meta) * 100}
                      aria-valuemin="0"
                      aria-valuemax="100"
                    ></div>
                  </div>
                </div>
                <span className="d-block detalhe-objetivo-font mt-3">
                  Faturado:{' '}
                  {cardData?.vendas?.toLocaleString('pt-br', {
                    style: 'currency',
                    currency: 'BRL',
                    maximumFractionDigits: 2
                  })}
                </span>
                <span className="d-block detalhe-objetivo-font">
                  Objetivo:{' '}
                  {cardData?.meta?.toLocaleString('pt-br', {
                    style: 'currency',
                    currency: 'BRL',
                    maximumFractionDigits: 2
                  })}
                </span>
              </div>
            ) : (
              <Skeleton count={1} />
            )}
          </div>
        </div>

        <div className="col-12 col-lg-4 mb-3">
          <div className="card shadow h-100 p-3">
            <span style={{ fontWeight: '700' }} className="text-uppercase font-weight-bold mb-1">
              Previsão de Objetivo
            </span>
            {typeof cardData?.previsaoObjetivo === 'number' ? (
              <div>
                <div className="row">
                  <span className="col mt-3" style={{ fontWeight: '700' }}>
                    {lib.formatToNumeric(
                      ((cardData?.vendas + cardData?.valorEmCarteira) / cardData?.meta) * 100,
                      2,
                      true
                    )}
                    %
                  </span>
                  <span className="col d-flex justify-content-flex-end mt-3">
                    {cardData?.performancePrevisaoObjetivo ? (
                      <span className="text-green">
                        <FontAwesomeIcon icon={faCheckCircle} className="mr-0" />
                        No Ritmo
                      </span>
                    ) : (
                      <span className="text-warning">
                        <FontAwesomeIcon icon={faTriangleExclamation} className="mr-0" />
                        Atrás
                      </span>
                    )}
                  </span>
                </div>

                <div className="col">
                  <div className="progress progress-sm mr-2">
                    <div
                      className="progress-bar bg-primary"
                      role="progressbar"
                      style={{
                        width: `${((cardData?.vendas + cardData?.valorEmCarteira) / cardData?.meta) * 100}%`
                      }}
                      aria-valuenow={
                        ((cardData?.vendas + cardData?.valorEmCarteira) / cardData?.meta) * 100
                      }
                      aria-valuemin="0"
                      aria-valuemax="100"
                    ></div>
                  </div>
                </div>

                <span className="d-block detalhe-objetivo-font mt-3">
                  Faturado:{' '}
                  {cardData?.vendas?.toLocaleString('pt-br', {
                    style: 'currency',
                    currency: 'BRL',
                    maximumFractionDigits: 2
                  })}{' '}
                  + Em Carteira:{' '}
                  {cardData?.valorEmCarteira?.toLocaleString('pt-br', {
                    style: 'currency',
                    currency: 'BRL',
                    maximumFractionDigits: 2
                  })}
                </span>
                <span className="d-block detalhe-objetivo-font">
                  Objetivo:{' '}
                  {cardData?.meta?.toLocaleString('pt-br', {
                    style: 'currency',
                    currency: 'BRL',
                    maximumFractionDigits: 2
                  })}
                </span>
              </div>
            ) : (
              <Skeleton count={1} />
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
